import React from 'react';
import type { RouteObject } from 'react-router-dom';
import { LoginPage } from '../pages/LoginPage';
import { routePatterns } from './paths';

export const publicRoutes: RouteObject[] = [
  { path: routePatterns.login, element: <LoginPage /> },
];
